import { render } from "./Inventory_Transfers_AddInvoice.vue?vue&type=template&id=17b67a78&scoped=true&ts=true"
import script from "./Inventory_Transfers_AddInvoice.vue?vue&type=script&lang=ts"
export * from "./Inventory_Transfers_AddInvoice.vue?vue&type=script&lang=ts"

import "./Inventory_Transfers_AddInvoice.vue?vue&type=style&index=0&id=17b67a78&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b67a78"]])

export default __exports__